/**
 * Gestion du répéteur "Pour chaque équipement composant la chaufferie après travaux"
 * pour les fiches PAC collectives (BAR-TH-178/179/180, BAT-TH-162/163/164 — arrêté du 27 avril 2026).
 *
 * - Clic sur "+ Ajouter un équipement" → clone le data-prototype et ajoute un bloc Équipement
 * - Clic sur "Supprimer" dans un bloc Équipement → retire le bloc du DOM
 * - Pas de bouton Supprimer sur l'Équipement n°1
 */
$(document).ready(function () {
    // ─── Toggle live du bloc Équipement selon INV_CHAUFF_EQUIP ───
    // Affiche/masque le wrapper .equipement-block-wrapper dynamiquement quand l'utilisateur
    // coche Oui (1) ou Non (2) sur INV_CHAUFF_EQUIP, sans attendre le submit.
    var $equipementBlockWrapper = $('.equipement-block-wrapper');
    if ($equipementBlockWrapper.length) {
        function updateEquipementBlockVisibility() {
            var $checked = $('input[name="ash_administration[INV_CHAUFF_EQUIP]"]:checked');
            var isOui = $checked.length && $checked.val() === '1';
            $equipementBlockWrapper.toggle(!!isOui);
        }
        $(document).on('change', 'input[name="ash_administration[INV_CHAUFF_EQUIP]"]', updateEquipementBlockVisibility);
        // État initial (au cas où l'utilisateur arrive sur la page avec une valeur déjà cochée)
        updateEquipementBlockVisibility();
    }

    var $container = $('.equipement-container');
    if ($container.length === 0) {
        return;
    }

    /**
     * Met à jour le numéro affiché dans le titre + remplace 'n°x' (placeholder yml) ou
     * 'n°<digit>' dans tous les labels du bloc Équipement par le numéro réel.
     */
    function renumberEquipements() {
        $container.children('.equipement').each(function (idx) {
            var num = idx + 1;
            var $eq = $(this);
            $eq.find('.equipement-index').first().text(num);
            var $removeBtn = $eq.find('.remove-equipement');
            if (idx === 0) {
                $removeBtn.hide();
            } else {
                $removeBtn.show();
            }
            $eq.find('label').each(function () {
                var $lbl = $(this);
                var txt = $lbl.text();
                if (/n°(x|\d+)/.test(txt)) {
                    $lbl.text(txt.replace(/n°(x|\d+)/g, 'n°' + num));
                }
            });
        });
    }

    var counter = $container.children('.equipement').length;

    function buildHeader(index, includeRemove) {
        var headerHtml = '<div class="row">' +
                '<div class="col-sm-12">' +
                    '<div class="ash_section_title" style="background:#f5f5f5;padding:8px 12px;">' +
                        'Équipement n°<span class="equipement-index">' + index + '</span>';
        if (includeRemove) {
            headerHtml +=
                        '<a href="#" class="remove-equipement" style="float:right;color:#c00;">' +
                            '<i class="fa fa-times-circle" title="Supprimer cet équipement"></i> Supprimer' +
                        '</a>';
        }
        headerHtml +=
                    '</div>' +
                '</div>' +
            '</div>';
        return headerHtml;
    }

    /**
     * Reconstruit la mise en page Twig pour chaque champ cloné :
     *   col-lg-12 + field-container + label + wrapper-input + widget
     * Chaque champ équipement est sur sa propre ligne (pleine largeur).
     */
    function layoutEquipementFields($protoContent) {
        var $protoFields = $protoContent.children();
        if ($protoFields.length === 0) return $('<div></div>');

        var $output = $('<div></div>');

        $protoFields.each(function () {
            var $protoField = $(this);
            var $label = $protoField.find('> label').first();
            var $widgetParts = $protoField.contents().filter(function () {
                return !(this.nodeType === 1 && $(this).is('label'));
            }).clone();

            var $fieldContainer = $('<div class="field-container padding-left-7"></div>');
            if ($label.length) {
                $fieldContainer.append($label.clone());
            }
            var $wrapperInput = $('<div class="wrapper-input padding-right-10 no-margin"></div>');
            $wrapperInput.append($widgetParts);
            $fieldContainer.append($wrapperInput);

            var $row = $('<div class="row"></div>');
            $row.append(
                $('<div class="col-lg-12"></div>').append($fieldContainer)
            );
            $output.append($row);
        });

        return $output;
    }

    $(document).on('click', '.add-equipement', function (e) {
        e.preventDefault();

        var prototype = $container.attr('data-prototype');
        var newHtml = prototype.replace(/__name__/g, counter);

        var $protoWrapper = $('<div>' + newHtml + '</div>');
        var $protoContent = $protoWrapper;
        if ($protoWrapper.children().length === 1 && $protoWrapper.children().first().is('div')) {
            $protoContent = $protoWrapper.children().first();
        }

        var $newEquip = $('<div class="equipement"></div>');
        $newEquip.append(buildHeader(counter + 1, true));
        var $layouted = layoutEquipementFields($protoContent);
        $layouted.children().each(function () {
            $newEquip.append(this);
        });

        $container.append($newEquip);
        counter++;
        renumberEquipements();
    });

    $(document).on('click', '.remove-equipement', function (e) {
        e.preventDefault();
        if (!confirm('Êtes-vous sûr de vouloir supprimer cet équipement ?')) {
            return;
        }
        $(this).closest('.equipement').remove();
        counter = $container.children('.equipement').length;
        renumberEquipements();
    });

    renumberEquipements();
});
